export enum CredentialsType {
    AppNexus = "appnexus",
    Google = "google",
    Saucelabs = "saucelabs",
    MFA = "mfa"
}
